module.exports = __webpack_public_path__ + "img/service-02.67e40dba.svg";